import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

export const CLI_REMOTE_SESSION_NOTICE_KEY = 'copilot_cli_remote_session_info'

interface NoticeDismissalResult {
  dismissed: boolean
}

async function fetchNoticeDismissal(): Promise<NoticeDismissalResult> {
  const resp = await verifiedFetchJSON(`/settings/notice-dismissals/${CLI_REMOTE_SESSION_NOTICE_KEY}`)
  if (!resp.ok) {
    throw new Error(`Failed to check notice dismissal: ${resp.status}`)
  }

  return (await resp.json()) as NoticeDismissalResult
}

/**
 * Deferred route query that prefetches the CLI remote session notice dismissal state.
 * Uses default staleTimeForNavigation (200ms) so it refetches on navigation.
 */
export const noticeDismissalRouteQuery = {
  queryName: 'noticeDismissal',
  queryFn: async (): Promise<NoticeDismissalResult> => fetchNoticeDismissal(),
  type: QueryRouteQueryType.Deferred,
} as const
